<gl-base-modal (closeModal)="onClose()">
  <h2 class="title">{{ 'share_project_modal_header' | translate }}</h2>
  @if (!isGeneratedLink) {
    <form [formGroup]="saveForm" (ngSubmit)="onSubmit()">
      <label class="nameLabel">{{'project_name' | translate}}</label>
      <gl-input-container>
        <input
          type="text"
          normal-input
          formControlName="name"
          />
      </gl-input-container>
      <p class="info">{{ projectDescription }}</p>
      <div class="textarea-wrapper">
        <div class="projectNotes">{{ 'project_notes' | translate }}:</div>
        <textarea
          class="textarea"
          formControlName="note"
          maxlength="500"
        ></textarea>
      </div>
      <div class="checkbox">
        <gl-checkbox
          formControlName="saveOption"
          [defaultChecked]="true"
        >{{ 'overwrite_changes' | translate }}</gl-checkbox>
      </div>
      <div class="buttons">
        <button normal-outline-button type="submit">
          {{ 'generate_link' | translate }}
        </button>
      </div>
    </form>
  }
  @if (isGeneratedLink) {
    <form [formGroup]="linkForm">
      <gl-input-container (click)="copyLink()" class="link-input">
        <input
          type="text"
          normal-input
          placeholder="share_project_modal_link_label"
          formControlName="link"
          readonly
          #linkInput
          />
      </gl-input-container>
      @if (success) {
        <p class="success">
          {{ 'share_project_modal_link_copied' | translate }}
        </p>
      }
      <div class="buttons">
        <button type="button" (click)="copyLink()" normal-outline-button>
          {{ 'share_project_modal_copy_link' | translate }}
        </button>
      </div>
    </form>
  }
</gl-base-modal>
